import { getPropertyValue } from 'framework-asset-preview-lib/internal/shared/utils/crmObject';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import CheckMarks from 'framework-asset-preview-lib/internal/objectTypes/0-830/components/CheckMarks';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function getWhatsAppPerformanceStats(crmObject) {
  const overviewPerformanceGroup = {
    stats: [{
      formatStyle: 'decimal',
      propertyName: 'hs_stats_sent',
      label: /*#__PURE__*/_jsx(LabelWithMarks, {
        property: "hs_stats_sent"
      }),
      value: getPropertyValue(crmObject, 'hs_stats_sent') || 0
    }, {
      formatStyle: 'decimal',
      propertyName: 'hs_stats_delivered',
      label: /*#__PURE__*/_jsx(LabelWithMarks, {
        property: "hs_stats_delivered"
      }),
      value: getPropertyValue(crmObject, 'hs_stats_delivered') || 0
    }, {
      formatStyle: 'decimal',
      propertyName: 'hs_stats_read',
      label: /*#__PURE__*/_jsx(LabelWithMarks, {
        property: "hs_stats_read"
      }),
      value: getPropertyValue(crmObject, 'hs_stats_read') || 0
    }, {
      formatStyle: 'decimal',
      propertyName: 'hs_stats_total_clicks',
      value: getPropertyValue(crmObject, 'hs_stats_total_clicks') || 0
    }, {
      formatStyle: 'decimal',
      propertyName: 'hs_stats_unique_clicks',
      value: getPropertyValue(crmObject, 'hs_stats_unique_clicks') || 0
    }, {
      formatStyle: 'decimal',
      propertyName: 'hs_stats_total_quick_replies',
      value: getPropertyValue(crmObject, 'hs_stats_total_quick_replies') || 0
    }, {
      formatStyle: 'percentage',
      propertyName: 'hs_stats_click_rate',
      value: getPropertyValue(crmObject, 'hs_stats_click_rate') || 0
    }, {
      formatStyle: 'percentage',
      propertyName: 'hs_stats_reply_rate',
      value: getPropertyValue(crmObject, 'hs_stats_reply_rate') || 0
    }],
    title: I18n.text('frameworkAssetPreviewLib.tabs.performance.performanceGroup.0-830.overview')
  };
  const deliveryPerformanceGroup = {
    stats: [{
      formatStyle: 'decimal',
      propertyName: 'hs_stats_dropped',
      value: getPropertyValue(crmObject, 'hs_stats_dropped') || 0
    }, {
      formatStyle: 'decimal',
      propertyName: 'hs_stats_failed',
      value: getPropertyValue(crmObject, 'hs_stats_failed') || 0
    }, {
      formatStyle: 'percentage',
      propertyName: 'hs_stats_delivery_rate',
      value: getPropertyValue(crmObject, 'hs_stats_delivery_rate') || 0
    }],
    title: I18n.text('frameworkAssetPreviewLib.tabs.performance.performanceGroup.0-830.delivery')
  };
  const groups = [overviewPerformanceGroup, deliveryPerformanceGroup];
  const sendingMethod = getPropertyValue(crmObject, 'hs_sending_method');
  if (sendingMethod === 'CRM') {
    const crmSendsPerformanceGroup = {
      stats: [{
        formatStyle: 'custom',
        propertyName: 'hs_crm_sends'
      }],
      title: I18n.text('frameworkAssetPreviewLib.propertyLabel.0-830.crmSendsByUser.displayName')
    };
    groups.push(crmSendsPerformanceGroup);
  }
  return Promise.resolve(groups);
}
function LabelWithMarks({
  property
}) {
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    gap: "200",
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: `frameworkAssetPreviewLib.propertyLabel.0-830.${property}`
    }), /*#__PURE__*/_jsx(CheckMarks, {
      property: property
    })]
  });
}